<template>
  <div
    class="ad-pic"
    @click="markAdClick()"
  >
    <img
      @click="adClick"
      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-12-13/481fe5b8a00639ad625605d89f931e93.png"
      alt=""
    />
    <WxLink
      v-if="isWeixin && isMobile"
      username="gh_eb6aa072a31e"
      wxPath="/pages/dailylotto/dailylotto"
    />
  </div>
</template>
<script>
import WxLink from "@/components/wxLink.vue";
import {
  adClickData,
} from "@/utils/common";
export default {
  props: {
    isWeixin: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
  },
  components: { WxLink },
  data() {
    return {};
  },
  methods: {
    adClick() {
      if (this.isMobile) {
        window.location.href =
          "weixin://dl/business/?appid=wx4de13da05eaa2ef8&path=pages/dailylotto/dailylotto&env_version=release";
      } else {
        window.open("https://52choujiang.cn/", "_blank");
      }
    },
    markAdClick() {
      adClickData("h5_draw_adv", "h5抽奖广告位"); // 抽奖广告位
    },
  }
};
</script>
<style lang="scss" scoped>
.ad-pic {
  position: relative;
}
.ad-pic img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ad.vue